import React, { useState } from 'react';
import { usePageMeta } from '../lib/usePageMeta';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import Accordion from '../components/Accordion';
import CTABar from '../components/CTABar';
import InterestFormModal from '../components/InterestFormModal';
import { faqContent } from '../data/faqContent';

const FAQ: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  usePageMeta(
    'FAQ | Parsant',
    'Questions we hear before every engagement. Cost, who does the work, regulated environments, technology stack, and what happens after Hand-off.'
  );

  return (
    <main className="bg-void-black min-h-screen">
      <Nav onContactClick={() => setIsFormOpen(true)} />

      <section className="pt-32 pb-16">
        <div className="container mx-auto max-w-7xl px-6">
          <div className="eyebrow eyebrow-accent mb-4">FAQ</div>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-signal-white mb-6 tracking-tight leading-[1.08] max-w-4xl">
            Questions we hear before every engagement.
          </h1>
          <p className="text-xl text-steel measure">
            If yours isn't here, the conversation form has a free-text field. We read every one.
          </p>
        </div>
      </section>

      <section className="section-tight border-t border-grid-line">
        <div className="container mx-auto max-w-7xl px-6">
          <div className="max-w-4xl">
            <Accordion items={faqContent} />
          </div>
        </div>
      </section>

      <section className="section-cta border-t border-grid-line">
        <div className="container mx-auto max-w-7xl px-6">
          <CTABar onContactClick={() => setIsFormOpen(true)} />
        </div>
      </section>

      <Footer />
      <InterestFormModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </main>
  );
};

export default FAQ;
